import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import template from "./num_range_facet.html";

function NumRangeFacet(search_model, facet, expanded, active, custom) {
    Object.assign(this,  {
        "type": "numrange",
        "template": template,
        "caption": facet.caption,
        "name": facet.name,
        "icon": facet.icon || "fa-calendar",
        "colour": facet.colour || "light-sea-green",
        "custom": custom,
        "data": { "start": ko.observable(null), "end": ko.observable(null) },
        "selected": active.indexOf(facet.name) >= 0,
        "visible": ko.observable(true)
    });
    var f = this;
    if (this.selected) {
        var datum = search_model.faceting.active()[active.indexOf(facet.name)];
            if (datum) {
                this.data.start(datum.range.start);
                this.data.end(datum.range.end);
            }
    }
    this.selectFacet = function () {
        //var selector = facet.name == "facet_queries" ? data.key : ("{!tag=" + facet.name + "}" + facet.name + ":" + data.key);
        var selector = f.field || f.name;
        var idx = active.indexOf(selector);
        if (idx >= 0){
            search_model.faceting.active.splice(idx, 1);
            f.selected = false;
        } else {
                var range = ko.toJS(f.data);
                if (!range) {
                    f.selected = false;
                } else {
                    var r0  = range.start;
                    var r1 = range.end;
                    if (r0 === null || r0 === "") {
                        r0="*";
                    }
                    if (r1 === null || r1 === "") {
                        r1="*";
                    }
                    search_model.faceting.active.push({
                        "name": f.name,
                        "value": "[" + r0 + " TO " + r1 + "]",
                        "valueCaption": (range.start == null ? "": range.start) + " - " + (range.end == null ? "" : range.end),
                        "selector": f.name+":[" + r0 + " TO " + r1 + "]",
                        "caption": facet.caption,
                        "join": facet.join,
                        range: range
                    });
                    f.selected = true;
                }
            }
            search_model.pager.start_index(0);
            search_model.query_results();
        };
        this.expanded = ko.observable(expanded);
        this.expand = function () {
            f.expanded(!f.expanded());
        };

    }
export default NumRangeFacet;